import type { PublicApiKey } from '#packages/apilib';
import type { createEditorEventRegistryApi } from './api';

export const EditorEventRegistryApiKey: PublicApiKey<
  typeof createEditorEventRegistryApi
> = {
  name: 'EditorEventRegistryApi',
  public: true,
};
